import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Shell from "@/components/Shell";
import Login from "@/pages/Login";
import PublicLanding from "@/pages/PublicLanding";
import PublicProductOutline from "@/pages/PublicProductOutline";
import ArticleRedirect from "@/pages/ArticleRedirect";
import SsoHandoff from "@/pages/SsoHandoff";
import Products from "@/pages/Products";
import ProductHome from "@/pages/ProductHome";
import PathOverview from "@/pages/PathOverview";
import ModulePlayer from "@/pages/ModulePlayer";
import Quiz from "@/pages/Quiz";
import Certificate from "@/pages/Certificate";
import MyCertifications from "@/pages/MyCertifications";
import VerifyCertificate from "@/pages/VerifyCertificate";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<PublicLanding />} />
          <Route path="/preview/:pid" element={<PublicProductOutline />} />
          <Route path="/login" element={<Login />} />
          <Route path="/sso" element={<SsoHandoff />} />
          <Route path="/a/:articleId" element={<ArticleRedirect />} />
          <Route path="/c/:code" element={<VerifyCertificate />} />

          {/* Authenticated app */}
          <Route element={<ProtectedRoute><Shell /></ProtectedRoute>}>
            <Route path="/products" element={<Products forceShow />} />
            <Route path="/certifications" element={<MyCertifications />} />
            <Route path="/certificate/:pid/:rid" element={<Certificate />} />
            <Route path="/:pid" element={<ProductHome />} />
            <Route path="/:pid/:rid" element={<PathOverview />} />
            <Route path="/:pid/:rid/final" element={<Quiz />} />
            <Route path="/:pid/:rid/:sid/check" element={<Quiz />} />
            <Route path="/:pid/:rid/:sid/:mid" element={<ModulePlayer />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
